module.exports = "/cyber/_next/static/images/noResultsDark-b27b7e81ef42f755c81bee68ab1cebe2.png";